<template>
  <footer
    id="footer"
    class="footer dark-background"
    style="backdrop-filter: blur(10px); background: #101214cc"
  >
    <div class="footer-main">
      <div class="container">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6">
            <div class="footer-widget footer-about">
              <span href="/" class="logo">
                <span class="">
                  <mx3-logo force-dark />
                </span>
              </span>
              <p>
                Somos especialistas em ferramentas e máquinas de alta performance. Oferecemos uma ampla gama de equipamentos manuais, elétricos e industriais para profissionais e entusiastas que buscam qualidade e durabilidade.
              </p>

              <div class="social-links mt-4">
                <h5>Siga-nos nas Redes</h5>
                <div class="social-icons">
                  <a href="#" class="social-link" aria-label="Facebook" title="Facebook"><i class="bi bi-facebook"></i></a>
                  <a href="#" class="social-link" aria-label="Instagram" title="Instagram"><i class="bi bi-instagram"></i></a>
                  <a href="#" class="social-link" aria-label="Twitter" title="Twitter"><i class="bi bi-twitter-x"></i></a>
                  <a href="#" class="social-link" aria-label="LinkedIn" title="LinkedIn"><i class="bi bi-linkedin"></i></a>
                  <a href="#" class="social-link" aria-label="YouTube" title="YouTube"><i class="bi bi-youtube"></i></a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h4>Produtos</h4>
              <ul class="footer-links">
                <li><a href="/products">Ferramentas Elétricas</a></li>
                <li><a href="/products">Ferramentas Manuais</a></li>
                <li><a href="/products">Máquinas Industriais</a></li>
                <li><a href="/products">Equipamentos de Medição</a></li>
                <li><a href="/products">Acessórios e Consumíveis</a></li>
                <li><a href="/products?promocao=1">Ofertas Especiais</a></li>
              </ul>
            </div>
          </div>

          <div class="col-lg-2 col-md-6 col-sm-6">
            <div class="footer-widget">
              <h4>Institucional</h4>
              <ul class="footer-links">
                <li>
                  <a href="/sobre">Sobre Nós</a>
                </li>
                <li>
                  <a href="/orders">Status do Pedido</a>
                </li>
                <li>
                  <a href="/seguranca">Segurança na Compra</a>
                </li>
                <li>
                  <a href="/garantia">Garantia e Trocas</a>
                </li>
                <li>
                  <a href="/contato">Central de Ajuda</a>
                </li>
                <li>
                  <a href="/contato">Fale Conosco</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="footer-widget">
              <h4>Informações de Contato</h4>
              <div class="footer-contact">
                <div class="contact-item">
                  <i class="bi bi-geo-alt"></i>
                  <span
                    >R. Empresário João Rodrigues Alves, n° 125 (302b e 604b) -
                    Bancários, João Pessoa - PB, 58051-022</span
                  >
                </div>
                <div class="contact-item">
                  <i class="bi bi-telephone"></i>
                  <span>(83) 9 9149-3136</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-envelope"></i>
                  <span>contato@importmaisbrasil.com.br</span>
                </div>
                <div class="contact-item">
                  <i class="bi bi-clock"></i>
                  <span
                    >Segunda-Sexta: 8h-18h<br />Sábado: 9h-13h<br />Domingo:
                    Fechado</span
                  >
                </div>
              </div>

              <div class="app-buttons mt-4">
                <a href="#" class="app-btn" id="btnInstall">
                  <i class="bi bi-apple"></i>
                  <span>App Store</span>
                </a>
                <a href="#" class="app-btn" id="btnInstall2">
                  <i class="bi bi-google-play text-success"></i>
                  <span>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <div class="row gy-3 align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="copyright">
              <p>
                © <span>Copyright</span>
                <strong class="footer-brand">IMPORT MAIS BRASIL</strong>. Todos os direitos reservados.
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-md-12">
            <div
              class="d-flex flex-wrap justify-content-lg-end justify-content-center align-items-center gap-4"
            >
              <div class="payment-methods">
                <div class="payment-icons">
                  <img
                    src="/assets/img/logos/visa.png"
                    alt="visa"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/master.png"
                    alt="master"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/itau.png"
                    alt="itau"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/pix.png"
                    alt="pix"
                    style="
                      height: 25px;
                      width: 35px;
                      background-color: white !important;
                    "
                    class="rounded"
                  />
                  <img
                    src="/assets/img/logos/boleto.png"
                    alt="boleto"
                    style="height: 25px; background-color: white !important"
                    class="rounded"
                  />
                </div>
              </div>

              <div class="legal-links">
                <a href="/termos" @click.prevent="$router.push('/termos')">Termos</a>
                <a href="/privacidade" @click.prevent="$router.push('/privacidade')">Privacidade</a>
                <a href="/cookies" @click.prevent="$router.push('/cookies')">Cookies</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import templateMixin from "../mixins/templateMixin";

// export default {
//   name: "Footer",
//   mixins: [templateMixin],
//   mounted() {
//     // Inicializa as funcionalidades específicas do footer
//     this.initScrollTop();
//   },
//   created() {

export default {
  name: "Footer",
  mixins: [templateMixin],
  mounted() {
    this.initScrollTop();
    const btn = document.getElementById("btnInstall");
    if (btn) {
      btn.addEventListener("click", async () => {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;
          this.deferredPrompt = null;
        }
      });
    }
    const btn2 = document.getElementById("btnInstall2");
    if (btn2) {
      btn2.addEventListener("click", async () => {
        if (this.deferredPrompt) {
          this.deferredPrompt.prompt();
          const { outcome } = await this.deferredPrompt.userChoice;
          this.deferredPrompt = null;
        }
      });
    }
  },
  data() {
    return {
      deferredPrompt: null,
    };
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      const btn = document.getElementById("btnInstall");
      if (btn) btn.style.display = "block";
    });
  },
};
</script>


<style lang="scss">
.footer .footer-main .footer-links li:before {
  display: none !important;
}
.footer-links {
  margin-left: -15px !important;
}


/* Rodapé no padrão da versão de referência 2908_74.
   As cores de texto/fundo de cada tema ficam em css/main.css e css/main-light.css. */
.footer h4 {
  background: linear-gradient(135deg, #ff8c00 0%, #ffd700 100%) !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  font-weight: 800 !important;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.footer .footer-links a:hover {
  color: #ff8c00 !important;
}
.footer .contact-item i {
  color: #ff8c00 !important;
}
.footer .footer-brand {
  margin-left: 0.3em;
  background: linear-gradient(90deg, #ff8c00 0%, #ffb700 100%);
  -webkit-background-clip: text;
  background-clip: text;
  font-weight: 700;
}
.footer .payment-icons {
  display: flex;
  align-items: center;
  gap: 12px;
}
.footer .payment-icons img {
  display: block;
  width: auto;
  height: 25px;
  max-width: 52px;
  object-fit: contain;
}
.footer .social-links {
  display: block;
}
.footer .social-icons {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.footer .social-icons a i {
  font-size: 1.4rem;
  line-height: 1;
}
/* Logomarca centralizada horizontalmente na coluna do texto institucional */
.footer .footer-about .logo,
.footer .footer-about .logo > span {
  display: flex !important;
  justify-content: center;
  width: 100%;
}
.footer .social-icons a {
  transition: all 0.3s ease !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 52px !important;
  height: 52px !important;
  font-size: 1.4rem !important;
  border-radius: 50% !important;
  text-decoration: none;
}
.footer .social-icons a:hover {
  background: linear-gradient(135deg, #ff8c00 0%, #ffd700 100%) !important;
  color: #000000 !important;
  transform: translateY(-3px) scale(1.1);
  box-shadow: 0 5px 15px rgba(255, 140, 0, 0.3);
}
@media (max-width: 991px) {
  .footer-widget {
    margin-bottom: 1.5rem;
  }
}
@media (max-width: 767px) {
  .footer-main {
    text-align: center;
  }
  .footer-widget .social-icons {
    justify-content: center;
  }
  .footer-widget h4 {
    margin-top: 0.5rem;
  }
  .footer .logo {
    display: flex;
    justify-content: center;
  }
  .contact-item {
    justify-content: center;
    text-align: left;
  }
  .app-buttons {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .legal-links {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}
@media (max-width: 480px) {
  .footer h4 {
    font-size: 1rem;
  }
  .footer p,
  .footer .footer-links a,
  .footer .footer-contact span {
    font-size: 0.9rem;
  }
}
</style>